import { render, staticRenderFns } from "./ComposeTemplates.vue?vue&type=template&id=c0005374&"
import script from "./ComposeTemplates.vue?vue&type=script&lang=js&"
export * from "./ComposeTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports